import * as _ from 'lodash-es';
// Error instances (incl. PtErr, AWS S3ServiceException) have non-enumerable
// message/name, so JSON.stringify(err) === '{}' — making alert debug ctx opaque.
// Convert any Error value into a plain diagnostic object; recurse one level into
// plain objects so nested {err: Error} / PtErr.uniqDebugH are also surfaced.
const errToPlainObj = (err) => {
    const own = _.pickBy(err, (v, k) => !['stack', 'uniqDebugH', 'dumpDebugH'].includes(k));
    const obj = { name: err.name || 'Error', message: err.message, ...own };
    if (err.uniqDebugH)
        obj.uniqDebugH = serErrDebugH(err.uniqDebugH);
    return obj;
};
export const serErrVal = (val) => {
    if (val instanceof Error)
        return errToPlainObj(val);
    if (typeof val === 'bigint')
        return val.toString();
    if (_.isPlainObject(val))
        return serErrDebugH(val);
    return val;
};
// JSON.stringify throws "Do not know how to serialize a BigInt" on bigint ctx values — masking
// the real error at throw time (throwIfF message embed + prepareStackTrace print). Any debug ctx
// may carry one (wei/gwei counters), so every ctx stringify goes through this
export const jsonReplacerBigintSafeF = (_k, v) => typeof v === 'bigint' ? v.toString() : v;
export const serErrDebugH = (debugH) => {
    if (!debugH)
        return debugH;
    return _.mapValues(debugH, serErrVal);
};
